(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retractation-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const EMAIL_ACK_AVAILABLE = false; // passer à true une fois l'accusé de réception réellement branché

    document.addEventListener('DOMContentLoaded', () => {
      const modal = document.getElementById('retractation-modal');
      if (!modal) return;

      const dialogEl = modal.querySelector('dialog');
      const form = modal.querySelector('.retractation-form');
      const errorsBox = modal.querySelector('.retractation-modal__errors');
      const confirmation = modal.querySelector('[data-confirmation]');
      const confirmationText = modal.querySelector('[data-confirmation-text]');
      const submitButton = modal.querySelector('[data-submit-button]');
      const buttonText = modal.querySelector('[data-button-text]');
      const itemsWrapper = modal.querySelector('[data-items-wrapper]');
      const itemsField = modal.querySelector('#RetractationForm-items');
      const scopeRadios = Array.from(modal.querySelectorAll('[data-scope-radio]'));

      if (!form || !dialogEl) return;

      let isSubmitting = false;
      const originalButtonLabel = buttonText ? buttonText.textContent : 'Confirmer la rétractation';

      // --- Ouverture depuis n'importe quel lien href="#retractation" ---
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[href="#retractation"]');
        if (!trigger) return;
        event.preventDefault();
        modal.showDialog();
      });

      // Ouverture directe via https://.../#retractation au chargement de la page
      if (window.location.hash === '#retractation') {
        modal.showDialog();
      }

      // Réinitialise la modale à sa fermeture, pour une réouverture propre
      modal.addEventListener('dialog:close', resetModal);

      // --- Champ conditionnel "Article(s) concerné(s)" ---
      scopeRadios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const isPartial = modal.querySelector('[data-scope-partial]')?.checked;
          itemsWrapper.hidden = !isPartial;
        });
      });

      // --- État renvoyé par Shopify après une soumission native (voir plus bas) ---
      handleServerState();

      // --- Validation, puis soumission NATIVE du formulaire ---
      // Shopify protège ce formulaire de contact par un challenge anti-bot
      // (hCaptcha) qui s'accroche à l'évènement submit natif du navigateur.
      // Intercepter la soumission pour la refaire nous-mêmes en fetch()
      // court-circuite ce challenge et fait échouer l'envoi ("Missing CAPTCHA
      // token"). On laisse donc la soumission suivre son cours normal (donc
      // une navigation) une fois la validation client passée ; Shopify
      // recharge la page et on rouvre la modale au bon état ci-dessous.
      form.addEventListener('submit', (event) => {
        if (isSubmitting) {
          event.preventDefault();
          return;
        }

        const errors = validateForm();
        if (errors.length) {
          event.preventDefault();
          showErrors(errors);
          return;
        }

        hideErrors();
        stampHiddenFields();

        isSubmitting = true;
        submitButton.disabled = true;
        if (buttonText) buttonText.textContent = 'Envoi en cours…';
        submitButton.classList.add('retractation-form__submit--loading');
        // Pas de preventDefault : la navigation part maintenant.
      });

      function validateForm() {
        const errors = [];
        const firstName = form.querySelector('[name="contact[Prénom]"]');
        const lastName = form.querySelector('[name="contact[Nom]"]');
        const email = form.querySelector('[name="contact[email]"]');
        const orderNumber = form.querySelector('[name="contact[Numéro de commande]"]');
        const scope = form.querySelector('[data-scope-radio]:checked');

        if (!firstName.value.trim()) errors.push('Veuillez renseigner votre prénom.');
        if (!lastName.value.trim()) errors.push('Veuillez renseigner votre nom.');
        if (!email.value.trim() || !isValidEmail(email.value.trim())) {
          errors.push('Veuillez saisir une adresse e-mail valide.');
        }
        if (!orderNumber.value.trim()) errors.push('Veuillez renseigner votre numéro de commande.');
        if (!scope) {
          errors.push('Veuillez préciser si votre demande concerne toute la commande ou certains articles.');
        } else if (scope.hasAttribute('data-scope-partial') && !itemsField.value.trim()) {
          errors.push('Veuillez indiquer les articles concernés.');
        }

        return errors;
      }

      function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      function showErrors(errors) {
        if (!errorsBox) return;
        errorsBox.innerHTML = errors.map((message) => `<p>${message}</p>`).join('');
        errorsBox.hidden = false;
        errorsBox.focus();
      }

      function hideErrors() {
        if (!errorsBox) return;
        errorsBox.hidden = true;
        errorsBox.innerHTML = '';
      }

      function stampHiddenFields() {
        const firstName = form.querySelector('[name="contact[Prénom]"]').value.trim();
        const lastName = form.querySelector('[name="contact[Nom]"]').value.trim();
        const email = form.querySelector('[name="contact[email]"]').value.trim();
        const orderNumber = form.querySelector('[name="contact[Numéro de commande]"]').value.trim();
        const scope = form.querySelector('[data-scope-radio]:checked');
        const scopeValue = scope ? scope.value : '';
        const items = itemsField.value.trim();

        const now = new Date();
        const readableDate = now.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
        const readableTime = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
        const isoTimestamp = now.toISOString();

        form.querySelector('[name="contact[name]"]').value = `${firstName} ${lastName}`;
        form.querySelector('[name="contact[Date de soumission]"]').value = readableDate;
        form.querySelector('[name="contact[Heure de soumission]"]').value = readableTime;
        form.querySelector('[name="contact[Horodatage ISO]"]').value = isoTimestamp;

        const bodyLines = [
          'Type de demande : Rétractation',
          '',
          `Prénom : ${firstName}`,
          `Nom : ${lastName}`,
          `Email : ${email}`,
          `Numéro de commande : ${orderNumber}`,
          `Portée de la demande : ${scopeValue}`,
        ];
        if (items) bodyLines.push(`Article(s) concerné(s) : ${items}`);
        bodyLines.push('', `Date de soumission : ${readableDate}`, `Heure de soumission : ${readableTime}`, `Horodatage ISO : ${isoTimestamp}`);
        form.querySelector('[name="contact[body]"]').value = bodyLines.join('\n');
      }

      // Après une soumission native, Shopify recharge la page : on détecte le
      // marqueur rendu côté Liquid (form.posted_successfully? / form.errors)
      // et on rouvre la modale directement dans le bon état.
      function handleServerState() {
        const marker = modal.querySelector('[data-retractation-state]');
        if (!marker) return;
        const state = marker.getAttribute('data-retractation-state');

        if (state === 'success') {
          if (EMAIL_ACK_AVAILABLE) {
            confirmationText.textContent =
              "Votre demande de rétractation a bien été prise en compte. Un accusé de réception récapitulatif vient de vous être envoyé par e-mail. Conservez cet e-mail comme confirmation de votre demande.";
          } else {
            confirmationText.textContent = 'Votre demande de rétractation a bien été transmise à LeoFeel.';
          }
          form.hidden = true;
          confirmation.hidden = false;
          modal.showDialog();
          requestAnimationFrame(() => confirmation.focus());
        } else if (state === 'error') {
          showErrors([
            "Une erreur est survenue lors de l'envoi de votre demande. Veuillez réessayer. Si le problème persiste, vous pouvez nous contacter directement depuis notre page Contact.",
          ]);
          modal.showDialog();
        }
      }

      function resetModal() {
        if (window.location.hash === '#retractation') {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        form.reset();
        form.hidden = false;
        confirmation.hidden = true;
        hideErrors();
        itemsWrapper.hidden = true;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
